import { createContext } from 'react';

import type { LearnDashboardContextState } from './types';

export const LearnDashboardContext = createContext<
  LearnDashboardContextState | undefined
>(undefined);
